<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-activity" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Service Manager</h4>
              <small style="opacity: 0.8;">Add and manage services &amp; investigations</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Tab bar -->
          <div class="card shadow-sm tab-card mb-4">
            <div class="card-body py-3 px-4">
              <div class="d-flex flex-wrap" style="gap: 8px;">
                <button class="btn btn-sm tab-btn"
                  :class="showService ? 'active-tab' : 'btn-outline-secondary'"
                  @click="showService = true; showCategory = false">
                  <i class="fe fe-plus mr-1"></i> Add Service
                </button>
                <button class="btn btn-sm tab-btn"
                  :class="showCategory ? 'active-tab' : 'btn-outline-secondary'"
                  @click="showService = false; showCategory = true">
                  <i class="fe fe-tag mr-1"></i> Service Categories
                </button>
              </div>
            </div>
          </div>

          <div v-show="showService"><AddService /></div>
          <div v-show="showCategory"><AddServiceCategory /></div>

        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import AddService from "@/views/drugs/AddService.vue";
import AddServiceCategory from "@/views/drugs/AddServiceCategory.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
    AddService,
    AddServiceCategory,
  },
  data() {
    return {
      user: null,
      providers: "",
      agencies: "",
      edit: false,
      showService: true,
      showCategory: false,
      isLoading: false,
      fullPage: true,
      services: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    //
  },
  created() {
    //
  },
};
</script>
<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}

.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tab-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.tab-btn {
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.82rem;
  padding: 6px 14px;
}

.active-tab {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-color: transparent;
  color: #fff;
}
</style>
